<!--页面代码从这里开始拷贝-->
<template>
  <div>
    <table-compnent
      :records="tableData"
      @resetHandler="reset"
      @searchHandler="doSearch"
      @queryByIdHandler="queryById"
      @deleteByIdHandler="deleteById"
      @batchDeleteHandler="batchDelete"
      @addHandler="saveSysAutoTestCase(project)"
    >
      <template v-slot:search>
        <el-form-item label="项目名称:">
          <el-input v-model="project.name" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item label="测试用例名称:">
          <el-input v-model="search.name" placeholder="测试用例名称"></el-input>
        </el-form-item>
      </template>
      <template v-slot:moreOpt>
        <el-button type="primary" @click="testCaseConfig"
          >自动化测试项目配置</el-button
        >

        <el-button type="success" @click="allTestCaseExcute"
          >一键执行当前项目测试用例</el-button
        >

        
      </template>
      <template v-slot:content>
        <el-table-column prop="name" label="测试用例名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column
          prop="updateTime"
          label="最近更新时间"
        ></el-table-column>
      </template>

      <template v-slot:operation="row" >
        <el-button type="text" size="small" @click="setUpSteps(row.record)"
          >设置步骤</el-button
        >
        <el-button
          type="text"
          size="small"
          @click="excuteTestCase(row.record, 'single')"
          >执行当前测试用例</el-button
        >
        <el-button type="text" size="small" @click="moveUp(row.record,row.rowMeta.$index)"
          >上移</el-button
        >

        <el-button type="text" size="small" @click="moveDown(row.record,row.rowMeta.$index)"
          >下移</el-button
        >
      </template>
    </table-compnent>

    <el-dialog
      width="35%"
      title="自动化测试项目配置"
      :visible.sync="dialogTableVisible"
    >
      <el-form label-position="right" label-width="180px">
        <el-form-item label="sessionStorageKey：">
          <el-col :span="15">
            <el-input
              v-model="sessionStorageKey"
              placeholder="请设置sessionStorageKey，用逗号隔开"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="localStorageKey:">
          <el-col :span="15">
            <el-input
              v-model="localStorageKey"
              placeholder="请设置localStorageKey，用逗号隔开"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="cookieKey:">
          <el-col :span="15">
            <el-input
              v-model="cookieKey"
              placeholder="请设置cookieKey，用逗号隔开"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSaveConfig">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      width="30%"
      title="请选择所有在线执行机器"
      :visible.sync="excuteVisible"
    >
      <el-form>
        <el-form-item label="执行域名：">
          <el-col :span="15">
             <el-input
              v-model="chooseEnv"
              placeholder="请输入执行域名，留空则默认则不替换域名..."
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="执行平台：">
          <el-col :span="15">
            <el-select
              v-model="choosePlatform"
              placeholder="所属平台"
              style="margin-right: 20px"
            >
              <el-option
                v-for="item in platforms"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="机器所属：">
          <el-col :span="15">
            <el-select
              v-model="chooseUser"
              placeholder="请选择执行机器..."
              style="margin-right: 20px"
            >
              <el-option
                v-for="item in onlineUsers"
                :key="item.id"
                :label="item.realName"
                :value="`${item.userId},${item.realName}`"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doExcuteTestCase">执行</el-button>
          <el-button @click="excuteCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
  
  <script>
import TableCompnent from "@/components/table/TablesComponents";
import SysAutoTestCaseApi from "@/api/SysAutoTestCaseApi";
import SysAutoTestStepApi from "@/api/SysAutoTestStepApi";
import SysProjectApi from "@/api/SysProjectApi";
import { navTo, queryParam } from "@/utils/NavigatorUtils";
export default {
  name: "SysAutoTestCaseList",
  props: {
    msg: String,
  },
  components: {
    TableCompnent,
  },
  data() {
    return {
      tableData: {},
      search: {
        objId: "",
      },
      dialogTableVisible: false,
      excuteVisible: false,
      page: {},
      project: "",
      cookieKey: "",
      sessionStorageKey: "",
      localStorageKey: "",
      chooseUser: "",
      choosePlatform: "",
      chooseEnv: "",
      onlineUsers: [],
      chooseCase: {},
      platforms: [
        {
          value: "chrome",
          label: "PC-Chrome",
        },
        {
          value: "firefox",
          label: "PC-FireFox",
        },
        // {
        //   value: "android",
        //   label: "Android平台",
        // },
        // {
        //   value: "ios",
        //   label: "iOS平台",
        // },
        // {
        //   value: "weapp",
        //   label: "小程序平台",
        // },
      ],
      excuteMode: "single",
    };
  },
  mounted() {
    this.project = this.$route.params.project;
    this.search.objId = this.project.id;
    this.cookieKey = this.project.cookieKey;
    this.sessionStorageKey = this.project.sessionStorageKey;
    this.localStorageKey = this.project.localStorageKey;
  },
  methods: {
    reset() {
      this.search = {};
    },
    doSearch(params) {
      this.page = params;
      this.search.pageSize = this.page.pageSize;
      this.search.pageNum = this.page.pageNum;
      SysAutoTestCaseApi.search(this.search).then((resp) => {
        if (resp.state == "OK") {
          this.tableData = resp.data;
        }
      });
    },
    saveSysAutoTestCase(obj) {
      queryParam(this, "saveSysAutoTestCase", {
        project: obj,
        data: { name: "" },
      });
    },
    queryById(id) {
      SysAutoTestCaseApi.querySysAutoTestCaseById(id).then((resp) => {
        if (resp.state == "OK") {
          queryParam(this, "saveSysAutoTestCase", {
            project: this.project,
            data: resp.data,
          });
        }
      });
    },
    deleteById(id) {
      SysAutoTestCaseApi.deleteSysAutoTestCase(id).then((resp) => {
        if (resp.state == "OK") {
          this.doSearch(this.page);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    batchDelete(params) {
      SysAutoTestCaseApi.batchDeleteSysAutoTestCase(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.doSearch(this.page);
        } else {
          this.$errorMsg(resp.msg);
        }
      });
    },
    setUpSteps(obj) {
      queryParam(this, "setUpSteps", { obj: obj });
    },
    excuteTestCase(obj, mode) {
      this.chooseCase = obj;
      this.excuteMode = mode;
      let data = {
        objId: obj.id,
        pageNum: 1,
        pageSize: 1000,
      };

      SysAutoTestStepApi.getOnlineUserId(data).then((resp) => {
        if (resp.state == "OK") {
          this.onlineUsers = resp.data;
          this.excuteVisible = true;
        }
      });
    },
    doExcuteTestCase() {
      let chooseUserArray = this.chooseUser.split(",");
      this.excuteVisible = false;
      if (this.excuteMode === "single") {
        let obj = this.chooseCase;
        let data = {
          id: obj.id,
        };
        SysAutoTestCaseApi.getTestCaseSteps(data).then((resp) => {
          if (resp.state == "OK") {
            let params = {
              // name: obj.name,
              // code: obj.code,
              type: "single",
              cookieKey: this.cookieKey,
              platform: this.choosePlatform,
              sessionStorageKey: this.sessionStorageKey,
              localStorageKey: this.localStorageKey,
              // tokenOpt: obj.tokenOpt,
              userName: chooseUserArray[0],
              nickName: chooseUserArray[1],
              domain:this.chooseEnv,
              defaultSteps: resp.data.defaultSteps,
              commonSteps: resp.data.commonSteps,
            };
            this.$wsKit.sendP2PTextMsg(
              "201910091558292",
              chooseUserArray[0],
              JSON.stringify(params)
            );
            this.choosePlatform = "";
            this.chooseUser = "";
          }
        });
      } else if (this.excuteMode === "all") {
        // this.excuteVisible = false;
        SysAutoTestCaseApi.getAllTestCase({ id: this.search.objId }).then(
          (resp) => {
            if (resp.state == "OK") {
              let params = {
                // name: obj.name,
                // code: obj.code,
                type: "all",
                cookieKey: this.cookieKey,
                platform: this.choosePlatform,
                sessionStorageKey: this.sessionStorageKey,
                localStorageKey: this.localStorageKey,
                // tokenOpt: obj.tokenOpt,
                userName: chooseUserArray[0],
                nickName: chooseUserArray[1],
                domain:this.chooseEnv,
                commonSteps: resp.data.commonSteps,
                defaultSteps: resp.data.defaultSteps,
              };
              console.log(params)
              this.$wsKit.sendP2PTextMsg(
                "201910091558292",
                chooseUserArray[0],
                JSON.stringify(params)
              );
              this.choosePlatform = "";
              this.chooseUser = "";
            }
          }
        );
      }
      
    },
    testCaseConfig() {
      this.dialogTableVisible = true;
    },

    doSaveConfig() {
      let params = {
        id: this.search.objId,
        cookieKey: this.cookieKey,
        sessionStorageKey: this.sessionStorageKey,
        localStorageKey: this.localStorageKey,
      };
      SysProjectApi.updateTestCaseTokenConfig(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.dialogTableVisible = false;
        }
      });
    },
    cancel() {
      this.dialogTableVisible = false;
    },
    excuteCancel() {
      this.excuteVisible = false;
    },
    allTestCaseExcute() {
      SysAutoTestStepApi.getOnlineUserId({}).then((resp) => {
        if (resp.state == "OK") {
          this.onlineUsers = resp.data;
          this.excuteVisible = true;
          this.excuteMode = "all";
        }
      });
    },
    moveUp(current,index){
      if(index==0){
        this.$errorMsg("当前元素为第一个元素，无法进行上移操作");
        return
      }
      let neighbour = this.tableData.records[index-1];
      let params = {
        currentId:current.id,
        currentSort:current.sort,
        neighbourId:neighbour.id,
        neighbourSort:neighbour.sort,
      }
      SysAutoTestCaseApi.moveUp(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.doSearch(this.page)
        }
      });
    },
    moveDown(current,index){
       if((index+1)==this.tableData.records.length){
        this.$errorMsg("当前元素为最后一个元素，无法进行下移操作");
        return
      }
      let neighbour = this.tableData.records[index+1];
      let params = {
        currentId:current.id,
        currentSort:current.sort,
        neighbourId:neighbour.id,
        neighbourSort:neighbour.sort,
      }
      SysAutoTestCaseApi.moveDown(params).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
          this.doSearch(this.page)
        }
      });
    }
  },
};
</script>
  <!--页面代码从这里结束拷贝-->